import { useMemo } from 'react';
import { clsx } from 'clsx';
import { Grid } from '../../../../alignment/grid';
import { Typography } from '../../../../typography';
import styles from './year-grid.module.scss';

interface YearGridProps {
  focusedYear: number;
  onSelectYear: (year: number) => void;
  yearOptions: number;
}

export function YearGrid({ focusedYear, onSelectYear, yearOptions }: YearGridProps) {
  const years = useMemo(() => {
    const options: number[] = [];
    const startYear = focusedYear - yearOptions + 1;

    for (let year = startYear; year < focusedYear + 1; year += 1) {
      options.push(year);
    }

    return options;
  }, [yearOptions, focusedYear]);

  return (
    <Grid autoColumns={4} className={styles.yearGrid} rowGap={2}>
      {years.map((year) => {
        const isActive = year === focusedYear;

        return (
          <button
            className={clsx(styles.option, isActive ? styles.isActive : undefined)}
            key={year}
            onClick={() => {
              onSelectYear(year);
            }}
            type="button"
          >
            <Typography lineHeight="0.875rem" size="0.875rem" tone={isActive ? 'background' : 'md'}>
              {year}
            </Typography>
          </button>
        );
      })}
    </Grid>
  );
}
